import { DateTime } from "luxon";

export class ServicePlanUtils {
    static isStarted(servicePlan) {
        return !servicePlan.startDate || DateTime.fromISO(servicePlan.startDate, { zone: "utc" }) <= DateTime.now();
    }

    static isExpired(servicePlan) {
        return servicePlan.endDate && DateTime.fromISO(servicePlan.endDate, { zone: "utc" }) <= DateTime.now();
    }

    static isActive(servicePlan) {
        return servicePlan && this.isStarted(servicePlan) && !this.isExpired(servicePlan);
    }

    static color(servicePlan) {
        if (servicePlan?.displayJson) {
            return servicePlan.displayJson.color;
        }
        return "";
    }

    static smallIconColor(servicePlan) {
        if (servicePlan?.displayJson) {
            return servicePlan.displayJson?.status_color ?? servicePlan?.displayJson?.color ?? null;
        }
        return null;
    }
}
